var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99609 3.99829V19.9929",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9918 11.9956C26.2002 11.9956 27.9905 10.2053 27.9905 7.99694C27.9905 5.78855 26.2002 3.99829 23.9918 3.99829C21.7834 3.99829 19.9932 5.78855 19.9932 7.99694C19.9932 10.2053 21.7834 11.9956 23.9918 11.9956Z",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99767 27.9905C10.2061 27.9905 11.9963 26.2002 11.9963 23.9918C11.9963 21.7834 10.2061 19.9932 7.99767 19.9932C5.78928 19.9932 3.99902 21.7834 3.99902 23.9918C3.99902 26.2002 5.78928 27.9905 7.99767 27.9905Z",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.992 11.9957C23.992 15.1772 22.7282 18.2285 20.4785 20.4781C18.2288 22.7278 15.1776 23.9917 11.9961 23.9917",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitBranch);
export default __webpack_public_path__ + "static/media/git-branch.6919319769fda6e7e28ff13faf2dc079.svg";
export { ForwardRef as ReactComponent };